import contentSecurityPolicyBuilder from 'content-security-policy-builder';
import ip from 'ip';

export default contentSecurityPolicyBuilder({
  directives: {
    reportUri: process.env.ONE_CLIENT_CSP_REPORTING_URL,
    defaultSrc: [
      "'self'",
      '*.americanexpress.com',
      'http://localhost',
      'unsafe-inline',
    ],
    frameSrc: [
      '*.americanexpress.com',
      '*.aexp.com',
      '*.cdn-path.com',
      '*.cdn-net.com',
    ],
    scriptSrc: [
      "'self'",
      'unsafe-inline',
      'https://qwww.aexp-static.com',
      'https://www.aexp-static.com',
      '*.aexp.com',
      '*.americanexpress.com',
      'localhost:3001',
      `${ip.address()}:3001`,
      '*.adobedtm.com',
      '*.cdn-path.com',
      '*.cdn-net.com',
    ],
    imgSrc: [
      "'self'",
      'https://dicm.intra.aexp.com',
      'https://qwww.aexp-static.com',
      'https://www.aexp-static.com',
      'https://www.americanexpress.com',
      '*.americanexpress.com',
    ],
    styleSrc: [
      "'self'",
      "'unsafe-inline'",
      'https://qwww.aexp-static.com',
      'https://www.aexp-static.com',
      '*.americanexpress.com',
    ],
    fontSrc: [
      'https://qwww.aexp-static.com',
      'https://www.aexp-static.com',
      '*.americanexpress.com',
    ],
    connectSrc: [
      "'self'",
      'https://qwww.aexp-static.com',
      'https://www.aexp-static.com',
      `${ip.address()}:3001`,
      '*.aexp.com',
      '*.americanexpress.com',
      '*.demdex.net',
    ],
  },
});
